export const getNumbersFromEndOfString = (inputString) => {
    if (!inputString || typeof inputString !== 'string') {
        return NaN;
    }

    try {
        return Number(inputString.match(/\d+$/));
    } catch (e) {
        console.error(`getNumbersFromEndOfString: ${e}`);
    }

    return NaN;
};
